export const rework_online_monitoring_helpers = {
  namespaced: true,
  state() { return {
    timeUpdateData: '', // Время последнего обневления данных по сменным заданиям
    reloadUpdateCount: 0, // Счётчик для автообновления данных, отслеживаем его через watch и при его изменении идёт обновление данных по сменным заданиям
    openTableWay: null, // Счётчик для автообновления данных, отслеживаем его через watch и при его изменении идёт обновление данных по сменным заданиям
  }},
  getters: {
    getTimeUpdateData: state => state.timeUpdateData,
    getReloadUpdateCount: state => state.reloadUpdateCount,
    getOpenTableWay: state => state.openTableWay,
  },
  actions: {
    resetState({ commit }) {
      commit('resetState');
    },
    setOpenTableWay({ commit }, payload) {
      commit('setOpenTableWay', payload);
    },
  },
  mutations: {
    setTimeUpdateData(state, payload) {
      state.timeUpdateData = payload
    },
    setReloadUpdateCount(state) {
      state.reloadUpdateCount += 1
    },
    resetState(state) {
      state.timeUpdateData = '';
      state.reloadUpdateCount = 0;
    },
    setOpenTableWay(state, payload) {
      state.openTableWay = payload
    },
  }
}